
import { Vue, prop, Options } from "vue-class-component";
import { PropType } from "vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ErrorMessageEntities } from "@/domain/entities/MainApp";
import { CargoController } from "@/app/ui/controllers/CargoController";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import { formatByCountry } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";

class Props {
}

@Options({
  components: {
    Skeleton
  }
})

export default class CargoDisputeSummary extends Vue.with(Props) {
  controller = CargoController
  isExpandMinimumWeightSummary = false;

  get isLoadingCargoDispute() {
    return CargoController.isLoadingCargoDispute
  }

  // Computed: Should show summary box
  get shouldShowSummary() {
    return FlagsPermissionCargo.permission_cargo_dispute_summary_enable.isEnabled()
  }

  // Computed: Cargo dipute summary data
  get cargoDisputeSummaryData() {
    return CargoController.cargoDisputeSummaryData
  }
  
  // Computed: Format date range display
  get dateRangeDisplay() {
    if (!this.cargoDisputeSummaryData.startDate || !this.cargoDisputeSummaryData.endDate) return "";
    
    const start = this.$moment(this.cargoDisputeSummaryData.startDate).format("DD MMM");
    const end = this.$moment(this.cargoDisputeSummaryData.endDate).format("DD MMM");
    
    return `${start} - ${end}`;
  }

  get cargoMinimumWeightSummary() {
    return CargoController.cargoMinimumWeightSummaryData
  }

  get minimumWeight() {
    return FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();
  }

  get volumeWeightFlag() {
    return this.minimumWeight !== 0;
  }

  mounted() {
    if(this.shouldShowSummary){
      if (getHubData()?.hubId) {
        CargoController.setHubIdsSelected([Number(getHubData()?.hubId)]);
      } else {
        CargoController.setHubIdsSelected([]);
      }
      this.getCargoDisputeSummary()
      CargoController.getCargoMinimumWeightSummary()

      if (this.volumeWeightFlag) this.isExpandMinimumWeightSummary = true;
    }
  }

  async getCargoDisputeSummary() {
    try {
      await CargoController.getCargoDisputeSummary();
    } catch (error) {
      MainAppController.showErrorMessage(
        new ErrorMessageEntities({
          type: "client-error",
          title: "Gagal mendapatkan cargo dispute summary!",
          onClose: () => {
            MainAppController.closeErrorMessage();
          },
        })
      );
    }
  }

  async onDownload(cargoType: string) {
    try {
      await CargoController.downloadExcelCargoSummaryDispute(cargoType);
    } catch (error) {
      MainAppController.showErrorMessage(
        new ErrorMessageEntities({
          type: "client-error",
          title: "Gagal mendownload data dispute summary!",
          onClose: () => {
            MainAppController.closeErrorMessage();
          },
        })
      );
    }
  }

  async onDownloadMinimumVolume() {
    try {
      await CargoController.downloadMinimumVolume();
    } catch (error) {
      MainAppController.showErrorMessage(
        new ErrorMessageEntities({
          type: "client-error",
          title: "Gagal mendownload data minimum weight!",
          onClose: () => {
            MainAppController.closeErrorMessage();
          },
        })
      );
    }
  }

  get countryCode() {
    return AccountController.accountData?.countryCode ?? "ID";
  }

  formatCurrency(percentage: number) {
    return formatByCountry(percentage, { type: "percentage", country: this.countryCode });
  }
}
